import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { GridRowModes } from "@mui/x-data-grid";
import { formatTribyteAccess, newRow } from "./constant";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { editCellContainerStyle } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { IoEyeOutline } from "react-icons/io5";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { saveOrDeleteMsg } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { gridComponents } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { selectStyles } from "views/pages/manage/masters/holidayMaster/common";
import MultiSelectCellComponentWithSearch from "views/pages/manage/common/commonComponents/SearchFilterView/MultiSelectCellComponentWithSearch";
import { isObjEmpty } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { generateRandomId } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import ActionsCellComponent from "./ActionCellComponent";
import moment from "moment";
import { Tooltip } from "@mui/material";
import NoRowOverlay from "views/pages/manage/masters/holidayMaster/NoRowOverlay";
import { getFormattedDate } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
//import StatusCellComponent from "./StatusCellComponent";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import StatusCellComponent from "./StatusCellComponent";
import CustomChip from "views/pages/manage/common/customChip/CustomChip";
import { regex } from "views/pages/manage/common/constant";
import { ReactComponent as ActiveControl } from 'assets/img/svg/ActiveControl.svg';
import { ReactComponent as InactiveControl } from 'assets/img/svg/InactiveControl.svg';
import { useModal } from "contexts/customModal";
import DateExtensionCaptureDialog, { displayExtensionDay } from "./DateExtensionCaptureDialog";
import CustomTooltip from 'views/pages/manage/common/customTooltip/CustomTooltip.jsx';

const ListComponent = forwardRef(
  (
    {
      currentPage = 0,
      currPageSize,
      rowCount,
      nextButtonHandler,
      dropdown,
      rows,
      loader,
      createHandler,
      updateHandler,
      isNew,
      setIsNew,
      toggleStatusHandler,
      isBranchLevelConfig,
      defaultRow,
      deleteHandler,
    },
    ref
  ) => {
    const [rowModesModel, setRowModesModel] = useState({});
    const { showModal, hideModal } = useModal();
    const [rowData, setRowData] = useState(rows);
    useEffect(() => setRowData(rows), [rows, defaultRow]);
    const [rowForm, setRowForm] = useState({});
    const rowFormHandler = (value, key) => {
      setRowForm((prev) => ({ ...prev, [key]: value }));
    }


    const startEditing = (id, form) => {
      setRowModesModel((oldModel) => ({ [id]: { mode: GridRowModes.Edit } }));
      setRowForm({
        ...form,
        itemType: dropdown?.itemTypes?.find(el => el?.label === form?.itemType),
        businessArea: dropdown?.activeBusinessAreas?.find(bu => bu?.label === form?.businessArea) ?? "",
        businessGroup: dropdown?.businessGroup?.find(bg => bg?.label === form?.businessGroup) ?? null,
        companyCode: typeof form?.companyCode === "object" ? form?.companyCode : dropdown?.companyCode?.find(
          cc => cc?.label === form?.companyCode
        ),
        academicCareer: typeof form?.academicCareer === "object" ? form?.academicCareer : dropdown?.academicCareer?.find(
          ac => ac?.label === form?.academicCareer
        ),
        mode: typeof form?.mode === "object" ? form?.mode : dropdown?.mode?.find(
          m => m?.label === form?.mode
        ),
        matrItemType: typeof form?.matrItemType === "object" ? form?.matrItemType : dropdown?.itemTypes?.find(
          el => el?.label === form?.matrItemType
        )
      });
    };


    const captureExpirationDate = (row) => {
      showModal({
        title: "Setup Extension",
        content: (
          <DateExtensionCaptureDialog
            onClose={hideModal}
            form={rowForm}
            rowFormHandler={rowFormHandler}
            saveHandler={handleSaveClick}
            row={row}
            closeModal={hideModal}
          />
        ),
      });
    }

    const stopEditing = () => {
      const currForm = { ...rowForm };
      setRowModesModel((oldModel) => ({
        [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
      }));
      setRowForm({});
    };

    const handleEditClick = (params) => {
      if (!isObjEmpty(rowForm)) {
        failureToast(saveOrDeleteMsg);
      } else {
        startEditing(params?.id, params?.row);
      }
    };
    const websiteHandler = async (val, params) => {
      if (params.api.getRowMode(params?.id) === "view") {
        if (!isObjEmpty(rowForm)) {
          failureToast(saveOrDeleteMsg);
          return;
        }
        else {
          const rowData = { ...params?.row, websiteIntegration: val }
          await updateHandler(rowData);
          stopEditing()
        }
      }
      else {
        rowFormHandler(val, "websiteIntegration")
      }
    }

    const admissionFormMatrHandler = async (val, params) => {
      if (params.api.getRowMode(params?.id) === "view") {
        if (!isObjEmpty(rowForm)) {
          failureToast(saveOrDeleteMsg);
          return;
        }
        else {
          const rowData = { ...params?.row, admissionFormEnabled: val }
          await updateHandler(rowData);
          stopEditing()
        }
      }
      else {
        rowFormHandler(val, "admissionFormEnabled")
      }
    }

    const feeComponentHandler = async (val, params) => {
      if (params.api.getRowMode(params?.id) === "view") {
        if (!isObjEmpty(rowForm)) {
          failureToast(saveOrDeleteMsg);
          return;
        }
        else {
          const rowData = { ...params?.row, isFeeComponent: val }
          await updateHandler(rowData);
          stopEditing()
        }
      }
      else {
        rowFormHandler(val, "isFeeComponent")
      }
    }

    const handleCancelClick = async (params) => {
      if (params?.row?.isNew) {
        setRowData(rows);
        setRowForm({});
        setIsNew(false)
      } else {
        stopEditing(params?.id);
      }
    };

    const handleSaveClick = async (form) => {
      const ticketId = form?.ticketId
      const activeDays = form?.activeDays


      // in case of specific BU add check 
      if (rowForm?.isNew) {
        await createHandler({ ...rowForm, activeDays, ticketId });
        setIsNew(false)
      } else {
        await updateHandler({ ...rowForm, activeDays, ticketId });
      }
    };

    const captureExpirationDateHandler = async (params) => {
      if (rowForm?.businessArea) {
        captureExpirationDate(rowForm)
        return;
      }
      handleSaveClick(params)
    }

    const mapDefaultRowToEditable = () => {
      if (!isBranchLevelConfig || !defaultRow) return {};

      return {
        businessGroup: defaultRow.businessGroup,
        companyCode: defaultRow.companyCode,
        academicCareer: defaultRow.academicCareer,
        itemType: defaultRow.itemType,
        matrItemType: defaultRow.matrItemType,
        mode: defaultRow.mode,
        tribyteAccess: defaultRow.tribyteAccess || [],
        minimumRegistrationPercentage: defaultRow.minimumRegistrationPercentage,
        minimumAdmissionPercentage: defaultRow.minimumAdmissionPercentage,
        minimumReadmitPercentage: defaultRow.minimumReadmitPercentage,
        discDays: defaultRow.discDays,
        websiteIntegration: defaultRow.websiteIntegration,
        isFeeComponent: defaultRow.isFeeComponent,
        afterEndDate: defaultRow?.afterEndDate,
        status: defaultRow.status || "ACTIVE",
        // must remain empty
        businessArea: "",
      };
    };


    const addNewRow = async () => {
      if (!isObjEmpty(rowForm)) {
        failureToast(saveOrDeleteMsg);
      } else {
        setIsNew(true)
        let randomId = generateRandomId();
        const prefilledValues = mapDefaultRowToEditable();
        let emptyRow = {
          ...newRow,
          ...prefilledValues,
          isNew: true,
          id: randomId
        };
        startEditing(randomId, emptyRow);
        setRowData((prev) => [emptyRow, ...prev]);
        // setRowData(prev => [
        //   ...prev?.slice(0, page * 50),
        //   emptyRow,
        //   ...prev?.slice(page * 50, prev?.length + 1),
        // ]);
      }
    };

    useImperativeHandle(ref, () => ({
      addNewRow: addNewRow,
      startEditing: startEditing,
      stopEditing: stopEditing,
    }));

    // const formatValue = (val) => {
    //   const arr = val.split(" ");
    //   return `${arr[0]} ${arr[1]}`;
    // };
    const handleTribyteAccessChange = (value = []) => {
      const isNoneSelected = value?.some(v => v?.value === "NONE");

      if (isNoneSelected) {
        // ONLY keep NONE
        rowFormHandler([{ label: "NONE", value: "NONE" }], "tribyteAccess");
      } else {
        // normal multi-select
        rowFormHandler(value, "tribyteAccess");
      }
    };
    const columns = [
      new AGridColDef("businessGroup", "Business Group", false)
        .setMinWidth(110)
        .editable(isNew)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.businessGroup}
              handleChange={(value) => rowFormHandler(value, "businessGroup")}
              items={dropdown?.businessGroup}
              isMulti={false}
              style={selectStyles}
              autoFocus={params?.hasFocus}
            />
          </div>
        )),

      new AGridColDef("companyCode", "Company Code", false)
        .setMinWidth(120)
        .editable(isNew)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.companyCode}
              handleChange={(value) => rowFormHandler(value, "companyCode")}
              items={dropdown?.companyCode}
              isMulti={false}
              style={selectStyles}
              autoFocus={params?.hasFocus}
            />
          </div>
        )),
      ...(isBranchLevelConfig ? [new AGridColDef("businessArea", "Business Area", false)
        .setMinWidth(120)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.businessArea}
              handleChange={(value) => rowFormHandler(value, "businessArea")}
              items={dropdown?.activeBusinessAreas}
              isMulti={false}
              style={selectStyles}
              autoFocus={params?.hasFocus}
            />
          </div>)
        )] : []),
      new AGridColDef("academicCareer", "Academic Career", true)
        .setMinWidth(110)
        .editable(isNew)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.academicCareer}
              handleChange={(value) => rowFormHandler(value, "academicCareer")}
              items={dropdown?.academicCareer}
              isMulti={false}
              style={selectStyles}
              autoFocus={params?.hasFocus}
            />
          </div>
        )),
      new AGridColDef("itemType", "Min Item Type", true)
        .setMinWidth(155)
        .editable(true)
        .setFlex(0.7)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.itemType}
              handleChange={(value) => rowFormHandler(value, "itemType")}
              items={dropdown?.itemTypes}
              isMulti={false}
              style={{ control: { ...selectStyles.control, width: '140px' } }}
              autoFocus={params?.hasFocus}
            />
          </div>
        )),
      new AGridColDef("minimumRegistrationPercentage", "Min Registration %", false)
        .setMinWidth(148)
        .editable(true)
        .setFlex(0.7)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}%</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AInput
              customIcon='%'
              customIconStyle={{ right: '8px' }}
              placeholder='Enter'
              value={rowForm?.minimumRegistrationPercentage}
              handler={(value) => rowFormHandler(value, "minimumRegistrationPercentage")}
              regex={regex?.percentage}
            />
          </div>
        )),
      new AGridColDef("minimumAdmissionPercentage", "Min Admission %", false)
        .setMinWidth(140)
        .editable(true)
        .setFlex(0.7)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}%</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AInput
              customIcon='%'
              customIconStyle={{ right: '8px' }}
              placeholder='Enter'
              value={rowForm?.minimumAdmissionPercentage}
              handler={(value) => rowFormHandler(value, "minimumAdmissionPercentage")}
              regex={regex?.percentage}
            />
          </div>
        )),
      new AGridColDef("minimumReadmitPercentage", "Min Readmit %", false)
        .setMinWidth(140)
        .editable(true)
        .setFlex(0.7)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}%</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AInput
              customIcon='%'
              customIconStyle={{ right: '8px' }}
              placeholder='Enter'
              value={rowForm?.minimumReadmitPercentage}
              handler={(value) => rowFormHandler(value, "minimumReadmitPercentage")}
              regex={regex?.percentage}
            />
          </div>
        )),
      new AGridColDef("tribyteAccess", "Tribyte Access", true)
        .setMinWidth(120)
        .editable(true)
        .setFlex(0.6)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value && formatTribyteAccess(params?.value)}>
            <div className={`ellipsis-text-container`}>{
              params?.value && formatTribyteAccess(params?.value)}</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.tribyteAccess}
              handleChange={handleTribyteAccessChange}
              items={dropdown?.academicGroup?.map(item => {
                const isNoneSelected = rowForm?.tribyteAccess?.some(
                  v => v?.value === "NONE"
                );

                return {
                  ...item,
                  isDisabled: isNoneSelected && item.value !== "NONE",
                };
              })}
              isMulti={true}
              isShowCount
              style={selectStyles}
              autoFocus={params?.hasFocus}
            />
          </div>
        )),
      new AGridColDef("matrItemType", "Matr Item type", true)
        .setMinWidth(120)
        .editable(true)
        .setFlex(0.6)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>
              {params?.value}</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.matrItemType}
              handleChange={(value) => rowFormHandler(value, "matrItemType")}
              items={dropdown?.itemTypes}
              isMulti={false}
              style={selectStyles}
              autoFocus={params?.hasFocus}
            />
          </div>
        )),
      new AGridColDef("discDays", "Disc days", true)
        .setMinWidth(120)
        .editable(true)
        .setFlex(0.6)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>
              {params?.value}</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AInput
              customIconStyle={{ right: '8px' }}
              placeholder='Enter'
              value={rowForm?.discDays}
              handler={(value) => rowFormHandler(value, "discDays")}
            />
          </div>
        )),
      new AGridColDef("admissionFormEnabled", "Admission Form", true)
        .setMinWidth(140)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          params?.value ?
            <ActiveControl onClick={() => admissionFormMatrHandler(false, params)} /> :
            <InactiveControl onClick={() => admissionFormMatrHandler(true, params)} />
        ))
        .renderEditCellComponent((params) => (
          (rowForm?.admissionFormEnabled) ?
            <ActiveControl onClick={() => admissionFormMatrHandler(false, params)} /> :
            <InactiveControl onClick={() => admissionFormMatrHandler(true, params)} />
        )),
      new AGridColDef("afterEndDate", <div className="d-flex align-items-center ">
        After End Date
        <Tooltip title="Number of days after the course End date used to determine Payment Collection eligibility. Should be less than 9999">
          <span className="d-flex align-items-center">
            <IoMdInformationCircleOutline
              className="ml-2 pointer"
              size={18}
            />
          </span>
        </Tooltip>
      </div>, true)
        .setMinWidth(175)
        .editable(true)
        .setFlex(0.6)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>
              {params?.value}</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AInput
              customIconStyle={{ right: '8px' }}
              placeholder='Enter'
              value={rowForm?.afterEndDate}
              handler={(value) => {
                if (value === "" || value === null) {
                  rowFormHandler("", "afterEndDate");
                } else if (value >= 0 && value <= 9999) {
                  rowFormHandler(value, "afterEndDate");
                }
              }}
            />
          </div>
        )),
      new AGridColDef("websiteIntegration", "Website Integration", true)
        .setMinWidth(110)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          params?.value ?
            <ActiveControl onClick={() => websiteHandler(false, params)} /> :
            <InactiveControl onClick={() => websiteHandler(true, params)} />
        ))
        .renderEditCellComponent((params) => (
          (rowForm?.websiteIntegration) ?
            <ActiveControl onClick={() => websiteHandler(false, params)} /> :
            <InactiveControl onClick={() => websiteHandler(true, params)} />
        )),
      new AGridColDef("isFeeComponent", "Extra Fee Component", true)
        .setMinWidth(110)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          params?.value ?
            <ActiveControl onClick={() => feeComponentHandler(false, params)} /> :
            <InactiveControl onClick={() => feeComponentHandler(true, params)} />
        ))
        .renderEditCellComponent((params) => (
          (rowForm?.isFeeComponent) ?
            <ActiveControl onClick={() => feeComponentHandler(false, params)} /> :
            <InactiveControl onClick={() => feeComponentHandler(true, params)} />
        )),
      new AGridColDef("mode", "Mode", false)
        .setMinWidth(110)
        .editable(isNew)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.mode}
              handleChange={(value) => rowFormHandler(value, "mode")}
              items={dropdown?.mode}
              isMulti={false}
              style={selectStyles}
              autoFocus={params?.hasFocus}
            />
          </div>
        )),
      new AGridColDef("createdBy", "Created By", false)
        .setMinWidth(120)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip></div> : <div>-</div>
        ))
      ,

      new AGridColDef("createdOn", "Created on", false)
        .setMinWidth(130)
        .setFlex(0.5)
        .renderCellComponent((params) =>
          params?.value ? (
            <div>
              {moment(params?.value)?.format("DD-MMM-YYYY")}
              <Tooltip
                title={`${getFormattedDate(params?.value)},
                    ${moment(params?.value).format("LT")}`}
              >
                <span>
                  <IoMdInformationCircleOutline
                    className="ml-2 pointer"
                    size={18}
                  />
                </span>
              </Tooltip>
            </div>
          ) : (
            <div>-</div>
          )
        ),
      new AGridColDef("updatedBy", "Updated By", false)
        .setMinWidth(120)
        .editable(true)
        .setFlex(0.5)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={`${moment(params?.row?.updatedOn).format('DD-MMM-YY')} by ${params.value}`}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip></div> : <div>-</div>
        ))
      ,
      new AGridColDef("status", "Status", false)
        .setMinWidth(200)
        .setFlex(0.5)
        .editable(true)
        .renderCellComponent((params) => (
          <>
            <CustomChip
              text={params?.value}
              textColor={params?.value == 'ACTIVE' ? '#07794C' : '#DC2804'}
              bgColor={params?.value == 'ACTIVE' ? '#E6F4ED' : '#FCEEED'}
            // style={{ fontSize: 12,fontWeight:'400px', fontFamily: 'Gilroy-SemiBold' }}
            />

            {params?.row?.activeDays != null && (
              <CustomTooltip
                title={displayExtensionDay(params?.row?.activeDays, params?.row?.ticketId)}
              >
                <span>
                  <IoMdInformationCircleOutline
                    className="ml-2 pointer"
                    size={18}
                  />
                </span>
              </CustomTooltip>)
            }
          </>
        ))
        .renderEditCellComponent((params) => (<StatusCellComponent
          params={params}
          toggleStatusHandler={toggleStatusHandler}
          rowForm={rowForm}
          rowFormHandler={rowFormHandler}
        />))
      ,
      new AGridColDef("actions", "Actions", false)
        .setMinWidth(130)
        .columnAlign("right")
        .setFlex(0.5)
        // .pinColumnLast(true)
        .renderCellComponent((params) => (
          <>
            <ActionsCellComponent
              params={params}
              handleEditClick={handleEditClick}
              handleCancelClick={handleCancelClick}
              handleSaveClick={captureExpirationDateHandler}
              rowForm={rowForm}
              isallowDelete={false}
              deleteHandler={deleteHandler}
            />
          </>
        )
        ),
    ];
    return (
      <div className="mt-3">
        <ADataGrid
          removeWrapperContainer
          rowModesModel={rowModesModel}
          rows={rowData || []}
          columns={columns}
          rowId={(row) => row?.id}
          rowHeight={50}
          loading={false}
          currentPage={currentPage}
          rowCount={rowCount}
          nextButtonHandler={nextButtonHandler}
          pageSize={10}
          paginationModel={{ page: currentPage, pageSize: currPageSize }}
          sx={{
            ...gridStyles,
          }}
          autoHeight
          hidePagination={!isBranchLevelConfig}
        // pinLastColumn
        />
      </div>
    );
  }
);
export default ListComponent;
